import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=3cf84b18"
import script from "./deleteDialog.vue?vue&type=script&lang=js"
export * from "./deleteDialog.vue?vue&type=script&lang=js"
import style0 from "./deleteDialog.vue?vue&type=style&index=0&id=3cf84b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports